import React, { useEffect, useState } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { BrandingContext } from './context/BrandingContext';
import { getBranding } from './services/api';
import { DEFAULT_BRANDING, API_BASE } from './utils/constants';
import AppRoutes from './routes/AppRoutes';

export default function App() {
  const [branding, setBranding] = useState(DEFAULT_BRANDING);

  useEffect(() => {
    getBranding().then(d => {
      if (!d || !d.primary_color) return;
      setBranding(d);
      document.documentElement.style.setProperty('--brand-primary', d.primary_color);
      document.documentElement.style.setProperty('--brand-accent',  d.accent_color);
      document.documentElement.style.setProperty('--dark',          d.dark_color);
    });
  }, []);

  return (
    <BrandingContext.Provider value={{ branding, API: API_BASE }}>
      <BrowserRouter>
        <AppRoutes />
      </BrowserRouter>
    </BrandingContext.Provider>
  );
}
